import { render, staticRenderFns } from "./EmbedVeridas.vue?vue&type=template&id=5f322286&scoped=true"
import script from "./EmbedVeridas.vue?vue&type=script&lang=js"
export * from "./EmbedVeridas.vue?vue&type=script&lang=js"
import style0 from "./EmbedVeridas.vue?vue&type=style&index=0&id=5f322286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f322286",
  null
  
)

export default component.exports